import logoMoney from './images/money.png';


const ClockIcon = (props) => {
  return (
    <img src={logoMoney} width={22} height={20} {...props} alt="fireMoney" />   
  );
}

export default ClockIcon